import React, { useState, useEffect } from "react";
import { AuditRecord, getAuditRecords } from "@/api/audits";
import JsonViewer from "@/ui-controls/JsonViewer";
import ShimmerList from "@/ui-controls/ShimmerList";

interface Props {
  AuditRecord: AuditRecord;
}

const AuditRecordDetailsDiff = (props: Props) => {
  const [records, setRecords] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => {
    if (props.AuditRecord) {
      loadDiff();
    }
  }, [props.AuditRecord]);

  const loadDiff = () => {
    setIsLoading(true);
    getAuditRecords(
      props.AuditRecord.EntityName,
      props.AuditRecord.ExternalId
    ).then(
      (result) => {
        const details = result.map((i: AuditRecord) => {
          return {
            EmailAddress: i.EmailAddress,
            EventType: i.EventType,
            Date: new Date(i.DateUtc).toLocaleDateString(),
            Time: new Date(i.DateUtc).toLocaleTimeString(),
            Payload: JSON.parse(i.Payload),
          };
        });

        setRecords(details);
        setIsLoading(false);
      },
      (error) => {
        handleError(error);
        setIsLoading(false);
      }
    );
  };

  const handleError = (error: Error) => {
    // Error handling would go here in real app
  };

  return (
    <>
      {isLoading ? (
        <ShimmerList numberOfColumns={6} />
      ) : (
        <JsonViewer object={records} />
      )}
    </>
  );
};

export default AuditRecordDetailsDiff;
